export default __webpack_public_path__ + "static/media/icon-youtube-green.a01a8d42.svg";